import { BindingError } from "@contember/binding";
const DataGridColumn = (props) => {
  throw new BindingError();
};
export {
  DataGridColumn
};
//# sourceMappingURL=DataGridColumn.js.map
